module.exports = __webpack_public_path__ + "static/media/light-youtube-icon.f296f653.svg";